import democratiseImage from 'marketing-website/media/images/pages/financial-services/democratise@2x.jpg';
import hero from 'marketing-website/media/images/pages/financial-services/hero@2x.jpg';
import ideateImage from 'marketing-website/media/images/pages/financial-services/ideate@2x.jpg';
import sharePreview from 'marketing-website/media/images/pages/enterprise/ogPreview.png';
import validateImage from 'marketing-website/media/images/pages/financial-services/validate@2x.jpg';

const assets = {
  hero: {
    alt: 'Disrupt and deliver with innovative Design Thinking',
    src: hero,
    maxWidth: 647,
  },
  ideate: {
    alt: 'Ideate, create and ship user-centric solutions',
    src: ideateImage,
    maxWidth: 647,
  },
  validate: {
    alt: 'Validate fast and reduce your time to market',
    src: validateImage,
    maxWidth: 734,
  },
  democratise: {
    alt: 'Democratise design and drive digital transformation',
    src: democratiseImage,
    maxWidth: 660,
  },
  sharePreview: {
    src: sharePreview,
    maxWidth: 1200,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/financial-services/assets.js